import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import OrderSerialNumbersTable from './components/OrderSerialNumbersTable';
import DeliveryNoteTable from './components/DeliveryNoteTable';
import { useLanguage } from '../../../contexts/LanguageContext';

const OrderPickupPage = () => {
  const { th } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="card">
      <div className="flex justify-content-between align-items-center mb-3">
        <h2 className="m-0">{th('menu.orderPickup')}</h2>
      </div>
      
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header={th('table.invoice')}>
          <OrderSerialNumbersTable />
        </TabPanel>
        <TabPanel header={th('table.deliveryNote')}>
          <DeliveryNoteTable />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default OrderPickupPage;
